import MovementsByTypeTable from './components/MovementsByTypeTable'
import MovementsByTypeForm from './components/MovementsByTypeForm'
import * as S from './MovementsByTypeTab.styles'

export default () => (
  <S.Wrapper>
    <MovementsByTypeForm />
    <MovementsByTypeTable/>
  </S.Wrapper>
)
